<template>
  <div class="form-group lm-date" v-if="showComponent" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
    />
    <div class="d-flex" :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <flat-pickr
        v-model="date"
        :config="config"
        :class="{'is-invalid': v.$error }"
        :placeholder="placeholder"
        :id="idComputed"
        readonly="false"
        :maxDate="maxDate"
        class="form-control"
        :disabled="disabled"
        ></flat-pickr>
      <div class="input-group-append">
        <button class="btn btn-default input-group-text" type="button" title="Clear" @click="date = ''" :disabled="disabled">
          <font-awesome-icon icon="times"/>
        </button>
      </div>
    </div>
    <p class="invalid-feedback d-block" v-if="!v.required && v.$error"> {{ $t('field_required')}} </p>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
library.add(faTimes)

export default {
  mixins: [lmInputMixin],
  props: {
    value: {
      type: String,
      default: null
    },
    minDate: {
      type: [String, Date]
    },
    maxDate: {
      type: Date
    },
    config: {
      type: Object,
      default: function () {
        return {
          dateFormat: 'd-m-Y',
          locale: Spanish,
          allowInput: true
        }
      }
    }
  },
  components: {
    flatPickr
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (value) {
        if (Object.entries(this.v).length) {
          this.v.$touch()
        }
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .flex-100
    flex: 1 0 0
    width: 1%
</style>
